var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticStyle:{"position":"fixed","right":"20px","bottom":"60px","z-index":"999"},attrs:{"href":_vm.config && _vm.config.customerServiceLink}},[_c('van-icon',{attrs:{"name":"service","size":"30","color":"#7832b0"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }